'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _InputConstants = require('./InputConstants');

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _ShareInput = require('../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _FieldsetContext = require('../context/FieldsetContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TYPES = ['text', 'email', 'number', 'password', 'search', 'url'];

var UITextInput = function (_PureComponent) {
  _inherits(UITextInput, _PureComponent);

  function UITextInput() {
    _classCallCheck(this, UITextInput);

    return _possibleConstructorReturn(this, (UITextInput.__proto__ || Object.getPrototypeOf(UITextInput)).apply(this, arguments));
  }

  _createClass(UITextInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          error = _props.error,
          inputRef = _props.inputRef,
          placeholder = _props.placeholder,
          styled = _props.styled,
          use = _props.use,
          rest = _objectWithoutProperties(_props, ['className', 'error', 'inputRef', 'placeholder', 'styled', 'use']);

      var fieldSize = this.context.size;


      return _react2.default.createElement('input', _extends({}, rest, {
        className: (0, _classnames2.default)('form-control private-form__control', _InputConstants.INPUT_SIZE_OPTIONS[fieldSize], className, {
          'private-form__control--unstyled uiTextInputUnstyled': !styled,
          'private-form__control--error': error
        }, _InputConstants.USE_CLASSES[use]),
        placeholder: (0, _lazyEval2.default)(placeholder),
        ref: inputRef
      }));
    }
  }]);

  return UITextInput;
}(_react.PureComponent);

UITextInput.contextType = _FieldsetContext.FieldsetContext;

UITextInput.propTypes = {
  defaultValue: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  error: _propTypes2.default.bool,
  inputRef: _refObject2.default,
  onChange: _propTypes2.default.func,
  placeholder: (0, _createLazyPropType2.default)(_propTypes2.default.string),
  readOnly: _propTypes2.default.bool,
  styled: _propTypes2.default.bool.isRequired,
  type: _propTypes2.default.oneOf(TYPES),
  use: _propTypes2.default.oneOf(Object.keys(_InputConstants.USE_CLASSES)),
  value: _propTypes2.default.string
};

UITextInput.defaultProps = {
  error: false,
  styled: true,
  type: 'text'
};

UITextInput.displayName = 'UITextInput';

exports.default = (0, _ShareInput2.default)(UITextInput);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/input/UITextInput.js
// module id = 215
// module chunks = 177